import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon, FacebookIcon, TwitterIcon, LinkedinIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-gray-900 text-white" data-id="element-46">
      <div className="container mx-auto px-4 py-12" data-id="element-47">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-48">
          {/* Company Info */}
          <div data-id="element-49">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6fopLqutiL5Rz4LYM4eKJT/003.png" alt="Daplamba Investments Limited" className="h-16 mb-4" data-id="element-50" />
            <p className="text-gray-400 mb-4" data-id="element-51">
              Your trusted partner for engineering solutions in Uganda and East
              Africa. Specializing in technical mechanical works, plumbing, and
              industrial system installations.
            </p>
            <div className="flex space-x-4" data-id="element-52">
              <a href="#" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-53">
                <FacebookIcon size={20} data-id="element-54" />
              </a>
              <a href="#" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-55">
                <TwitterIcon size={20} data-id="element-56" />
              </a>
              <a href="#" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-57">
                <LinkedinIcon size={20} data-id="element-58" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-59">
            <h3 className="text-xl font-semibold mb-4 border-b border-red-600 pb-2 inline-block" data-id="element-60">
              Quick Links
            </h3>
            <ul className="space-y-2" data-id="element-61">
              <li data-id="element-62">
                <Link to="/" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-63">
                  Home
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/about" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-65">
                  About Us
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/services" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-67">
                  Services
                </Link>
              </li>
              <li data-id="element-68">
                <Link to="/projects" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-69">
                  Projects
                </Link>
              </li>
              <li data-id="element-70">
                <Link to="/contact" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-71">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          {/* Services */}
          <div data-id="element-72">
            <h3 className="text-xl font-semibold mb-4 border-b border-red-600 pb-2 inline-block" data-id="element-73">
              Our Services
            </h3>
            <ul className="space-y-2" data-id="element-74">
              <li data-id="element-75">
                <Link to="/services" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-76">
                  Fire Protection Systems
                </Link>
              </li>
              <li data-id="element-77">
                <Link to="/services" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-78">
                  Underground Leakage Control
                </Link>
              </li>
              <li data-id="element-79">
                <Link to="/services" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-80">
                  Compressed Air Systems
                </Link>
              </li>
              <li data-id="element-81">
                <Link to="/services" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-82">
                  HVAC & Chiller Systems
                </Link>
              </li>
              <li data-id="element-83">
                <Link to="/services" className="text-gray-400 hover:text-red-600 transition-colors" data-id="element-84">
                  Oil & Gas Mechanical Services
                </Link>
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div data-id="element-85">
            <h3 className="text-xl font-semibold mb-4 border-b border-red-600 pb-2 inline-block" data-id="element-86">
              Contact Info
            </h3>
            <ul className="space-y-4" data-id="element-87">
              <li className="flex items-start" data-id="element-88">
                <MapPinIcon size={20} className="mr-2 text-red-600 flex-shrink-0 mt-1" data-id="element-89" />
                <span className="text-gray-400" data-id="element-90">Kampala, Uganda</span>
              </li>
              <li className="flex items-center" data-id="element-91">
                <PhoneIcon size={20} className="mr-2 text-red-600 flex-shrink-0" data-id="element-92" />
                <span className="text-gray-400" data-id="element-93">+256 123 456 789</span>
              </li>
              <li className="flex items-center" data-id="element-94">
                <MailIcon size={20} className="mr-2 text-red-600 flex-shrink-0" data-id="element-95" />
                <span className="text-gray-400" data-id="element-96">info@daplamba.com</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400" data-id="element-97">
          <p data-id="element-98">
            &copy; {new Date().getFullYear()} Daplamba Investments Limited. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;